import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function JoinUsTonight() {
  return <section data-section-id="241293" id="future-priority-supportive-housing" className="dark bg-background text-foreground relative py-24 md:py-32 lg:py-40 flex items-center justify-center min-h-[60vh] overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654300/img/supportive_housing_vision.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 z-10 bg-gradient-to-br from-primary/90 via-primary/70 to-accent/40" aria-hidden="true" />

      {}
      <div className="relative z-20 container mx-auto px-4 text-center flex flex-col items-center max-w-3xl">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-white mb-6 tracking-tight">
          Future Priority: Supportive Housing
        </h2>
        
        <p className="text-lg md:text-xl text-white/90 mb-10 font-default max-w-2xl">
          Stable housing is the next critical step in our roadmap. We are developing pathways to independent living that restore dignity and long-term stability.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center w-full sm:w-auto">
          <Button asChild size="lg" className="w-full sm:w-auto text-base h-14 px-8 shadow-xl bg-secondary text-secondary-foreground hover:bg-secondary/90">
            <Link to="/SupportUsPage">
              Support This Goal
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base h-14 px-8 text-white border-white/40 bg-transparent hover:bg-white/10 hover:text-white backdrop-blur-md">
            <Link to="/ProgramsPage">
              View Our Roadmap
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}